///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    templateUrl: './AppViews/Timesheet/editTimesheet.html'
})

export class EditTimesheetComponent implements OnInit {
    showLoader:boolean=false;
    invalidRecord: boolean = false;
    constants: Constants;
    timesheetDetails: any = {};
    projectList: any = [];
    taskList: any = [];
    timesheetItems: any = [];
    userDetail: any;
    teamItems:any[]=[];
    // TimeSheetDate:any=moment().format('DD/MM/YYYY');
    filter: any = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY') };
    editTimesheet: any = { 'ProjectId': "", 'TaskTypeId': "", 'TimeSpent': "", 'Comments': "" };
    editTimesheetFormActive: any = true;
    getProjectUrl: any;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.timesheetDetails.timeSheetUser = this.userDetail.SiteUserId;
        this.route
            .params
            .subscribe(
            data => {
                this.timesheetDetails.Timesheet_Id = data["timesheetId"];
                this.timesheetDetails.TimeSheetDate = this.datePipe.transform(data["timeSheetDate"], 'dd/MM/yyyy');
                var userId = data["timeSheetUser"];
                if(userId != undefined && userId != null)
                {
                this.timesheetDetails.timeSheetUser = data["timeSheetUser"];
                }
            }
            );
    }

    ngOnInit() {
        // if (this.userDetail.RoleId == 3) {
            this.getProjectUrl = "Project/GetAssignedProject"
        // } else {
        //     this.getProjectUrl = "Project/GetProject"
        // }
        this.GetProjectList();
    }

    ngAfterViewInit() {
        var today = moment().format('YYYY-MM-DD');
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY',
            maxDate: today
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    ngAfterViewChecked() {
        if (this.projectList.length > 0) {
            $('.project').selectpicker({
                style: 'btn-info',
                size: 4
            });

            $('.selectPicker').selectpicker({ style: 'btn-info' });
        }
    }

    GetProjectList() {
        this.showLoader=true;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            // if(this.userDetail.RoleId==3){
                 TeamId=0
            //  }else{
            //     TeamId = this.userDetail.TeamID;
            //  }
        }
        this._httpService.ajaxPost(this.getProjectUrl,
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 0, "UserId": UserId }).subscribe(
            data => {
                this.projectList = data["ProjectList"];       
            },
            err => { console.log("GetProjectList Failed");this.showLoader=false; },
            () => {
                if (this.timesheetDetails.Timesheet_Id != 0) {
                    this.GetTimesheet();
                }
                this.showLoader=false;
            }
            );
    }

    GetTaskList() {        
        if (this.editTimesheet.ProjectId != "") {
            this.showLoader=true;
            this._httpService.ajaxPost("TaskType/GetTaskTypeByProjectId",
                { "ProjectId": this.editTimesheet.ProjectId }).subscribe(
                data => {
                    this.taskList = data["TaskTypeList"];                    
                },
                err => {console.log("GetTaskList Failed");this.showLoader=false;},
                () => { this.showLoader=false; }
                );
        }
    }

    GetTimesheet() {
        this.showLoader=true;
        this._httpService.ajaxPost("Timesheet/GetTimesheet",
            {
                "TimesheetId": this.timesheetDetails.Timesheet_Id,
                "UserId": this.timesheetDetails.timeSheetUser,
                "ProjectId": 0,
                "FromDate": null,
                "ToDate": null,
                "TaskTypeId": 0,
                "TaskGroupId": 0,
                "TeamId": this.userDetail.TeamID,
                "LoggedInUser": this.userDetail.SiteUserId
            }).subscribe(
            data => {
                this.timesheetItems = data["TimesheetList"];
                this.editTimesheet.Comments = this.timesheetItems[0].Comments;
                this.editTimesheet.ProjectId = this.timesheetItems[0].ProjectId;
                this.editTimesheet.TimeSpent = this.timesheetItems[0].TimeSpent;
                this.editTimesheet.TaskTypeId = this.timesheetItems[0].TaskTypeId;
            },
            err => {console.log("GetTimesheetList Failed");this.showLoader=false;},
            () => { this.GetTaskList();this.showLoader=false; }
            );
    }

    ValidateTimesheet(controlName) {
        if (controlName == "") {
            this.invalidRecord = false;

            var ProjectId = $('#ProjectId').val();
            var TaskTypeId = $('#TaskTypeId').val();
            var Timespent = $('#TimeSpent').val();
            var Comments = $('#Comments').val();

            var isNumber = /^\d+$/.test(Timespent);
            if (ProjectId == "" && TaskTypeId == "" && (Timespent == "" || Timespent == "0" || isNumber == false) && Comments == "") {
                $('#ProjectId').siblings(".btn-info").removeAttr("style");
                $('#TaskTypeId').siblings(".btn-info").removeAttr("style");
                $('#TimeSpent').parent().removeClass("has-error");
                $('#Comments').parent().removeClass("has-error");
            }
            else {
                if (ProjectId == "") {
                    this.invalidRecord = true;
                    $('#ProjectId').siblings(".btn-info").attr("style", "border-color:#a94442 !important");
                }

                if (TaskTypeId == "") {
                    this.invalidRecord = true;
                    $('#TaskTypeId').siblings(".btn-info").attr("style", "border-color:#a94442 !important");
                }

                if (Timespent == "" || Timespent == "0" || isNumber == false) {
                    this.invalidRecord = true;
                    $('#TimeSpent').parent().addClass("has-error");
                }
                else {
                    if (isNaN(Timespent)) {
                        this.invalidRecord = true;
                        $('#TimeSpent').parent().addClass("has-error");
                    }
                }

                if (Comments == "") {
                    this.invalidRecord = true;
                    $('#Comments').parent().addClass("has-error");
                }
            }

            if (!this.invalidRecord) {
                this.UpdateTimesheet();
            }
        }
        else {
            var Control = $('#' + controlName).val();
            var isNo = /^\d+$/.test(Control);
            if (Control == "" || Control == "0") {
                this.invalidRecord = true;
                $('#' + controlName).parent().addClass("has-error");
                $('#' + controlName).siblings(".btn-info").attr("style", "border-color:#a94442 !important");
            }
            else {
                if (controlName == "TimeSpent" && isNo == false) {
                    $('#' + controlName).parent().addClass("has-error");
                }
                else {
                    $('#' + controlName).parent().removeClass("has-error");
                    $('#' + controlName).siblings(".btn-info").removeAttr("style");
                }

            }
        }

    }

    UpdateTimesheet() {
        if (this.editTimesheet.ProjectId == "" || this.editTimesheet.TaskTypeId == "" || this.editTimesheet.TimeSpent == "" || this.editTimesheet.TimeSpent == "0" || this.editTimesheet.Comments == "") {
            this._sharedService.ShowMessage("error|Enter valid record");
        }
        else {
            this.editTimesheet.TimeSheet_Id = this.timesheetDetails.Timesheet_Id;
            this.editTimesheet.UserId = this.userDetail.SiteUserId;
            this.editTimesheet.Created_By = this.userDetail.SiteUserId;
            this.editTimesheet.Modified_By = this.userDetail.SiteUserId;
            this.editTimesheet.TimeSheet_Date = this.timesheetDetails.TimeSheetDate;
            let objItem: any = [];
            let objRecord: any = {};
            objRecord.TimeSheet_Id = this.editTimesheet.TimeSheet_Id;
            objRecord.UserId = this.editTimesheet.UserId;
            objRecord.TimeSheet_Date = this.editTimesheet.TimeSheet_Date;
            objRecord.ProjectId = this.editTimesheet.ProjectId;
            objRecord.TaskTypeId = this.editTimesheet.TaskTypeId;
            objRecord.TimeSpent = this.editTimesheet.TimeSpent;
            objRecord.Comments = this.editTimesheet.Comments;
            objRecord.Created_By = this.editTimesheet.Created_By;
            objRecord.Modified_By = this.editTimesheet.Modified_By;
            objItem.push(objRecord);
            let objTimesheet: any = { "TimesheetList": objItem };
            this.showLoader=true;            
            this._httpService.ajaxPost('Timesheet/UpdateTimesheet', objTimesheet).subscribe(
                data => {
                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        //if (message[0] == "warning") {
                        //    //vm.isWarning = true;
                        //}
                        msg[0] = msg[0].toLowerCase();
                        //this._toasterService.pop(msg[0], msg[1]);
                        this._sharedService.ShowMessage(data["Status"].Message);

                        //redirect to timesheet page
                        this._route.navigateByUrl("/timesheet");
                    }
                    else {
                        //this._toasterService.pop('success', msg);
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                },err => { console.log("UpdateTimesheet Failed");this.showLoader=false; },
                () => { this.showLoader=false; }
            );
        }
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Timesheet/editTimesheet.component.ts
 **/